import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import { formatLocalizedTimeAgo } from "../../../../utils/formatDate";

import { ChatRoom } from "../../api/services/chat";
import { extractJsonFromText } from "../../utils/openAI";
import { ChatRoomHistoryIcon } from "../../assets/icons/gino-icons";
import { Link } from "react-router-dom";
import { getGinoChatRoomHistoryRoute } from "../../../../routers/routeUtils";

export const ChatRoomHistoryRow = ({ chat: { last_message, chatId } }: { chat: ChatRoom }) => {
  const { i18n } = useTranslation();
  const { text, created_at } = last_message || {};

  const json = extractJsonFromText(text!);

  const messageContent = json?.message ?? text;

  return (
    <Box sx={styles.chatRoomHistoryRow} component={Link} to={getGinoChatRoomHistoryRoute(chatId)}>
      <ChatRoomHistoryIcon />
      <Box sx={styles.chatRoomHistoryRowContent}>
        <Typography sx={styles.chatRoomHistoryRowContentText}>{messageContent}</Typography>
        <Typography sx={styles.chatRoomHistoryRowContentTime}>
          {formatLocalizedTimeAgo(new Date(created_at!).toISOString(), i18n.language)}
        </Typography>
      </Box>
    </Box>
  );
};

export const ChatRoomHistoryRowLoader = () => {
  return (
    <Box sx={{ ...styles.chatRoomHistoryRow, width: "100%" }}>
      <ChatRoomHistoryIcon />
      <Box sx={{ ...styles.chatRoomHistoryRowContent, flex: 1 }}>
        <Box sx={{ width: "100%" }}>
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="90%" height={24} />
        </Box>
        <Skeleton variant="text" width="20%" height={20} />
      </Box>
    </Box>
  );
};

const styles = {
  chatRoomHistoryRow: {
    display: "flex",
    gap: "12px",
    textDecoration: "none",
  },
  chatRoomHistoryRowContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  chatRoomHistoryRowContentText: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  chatRoomHistoryRowContentTime: {
    color: "var(--Dark---600, #707070)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
};
